import React, { useState } from 'react';
import { Button, Dialog, DialogActions } from '@material-ui/core';
import cedulaNueva from 'assets/img/cedula_nueva.svg';
import cedulaAntigua from 'assets/img/cedula_antigua.svg';
import 'assets/scss/info-serial-number-dialog.scss';
import checkIsMobile from 'utils/CheckIsMobile';

export const InfoSerialNumberModal = ({ toggle }: { toggle: any }) => {
	const [open, setOpen] = useState(true);

	const handleClose = () => {
		setOpen(false);
	};
	const size = checkIsMobile() ? 'medium' : 'large';

	return (
		<Dialog open={open} onClose={handleClose} className="info-serial-number-modal">
			<h1 className="title-4 primary-color">¿Dónde está el Nº de serie?</h1>
			<p className="info-serial-number-modal-subtitle body negro-general">
				Con este dato nos autorizas a consultar la deuda a portar con tu actual financiera.
			</p>
			<div className="info-serial-number-modal-body">
				<div>
					<p className="info-serial-number-img-title body-small primary-color">
						En la <b>Cédula nueva</b> lo encuentras aquí
					</p>
					<img src={cedulaNueva} alt="img" />
				</div>
				<div>
					<p className="info-serial-number-img-title body-small primary-color primary-color">
						En la <b>Cédula antigua</b> está aquí
					</p>
					<img src={cedulaAntigua} alt="img" />
				</div>
			</div>

			<DialogActions>
				<Button
					onClick={toggle}
					size={size}
					variant="contained"
					color="primary"
					style={{ width: 200 }}
				>
					Cerrar
				</Button>
			</DialogActions>
		</Dialog>
	);
};
